import { render } from "./CreateContactView.vue?vue&type=template&id=02fa901e"
import script from "./CreateContactView.vue?vue&type=script&lang=js"
export * from "./CreateContactView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__